import(/* webpackMode: "eager" */ "/app/components/AgentCardSlider.jsx");
import(/* webpackMode: "eager" */ "/app/components/BlogCardSlider.jsx");
import(/* webpackMode: "eager" */ "/app/components/CardCarouselSlider.jsx");
import(/* webpackMode: "eager" */ "/app/components/DistrictCardSlider.js");
import(/* webpackMode: "eager" */ "/app/components/Footers/FooterDefault.js");
import(/* webpackMode: "eager" */ "/app/components/Forms/ContactUsForm.jsx");
import(/* webpackMode: "eager" */ "/app/components/Forms/NewsletterForm.jsx");
import(/* webpackMode: "eager" */ "/app/components/Forms/RecruitmentForm.jsx");
import(/* webpackMode: "eager" */ "/app/components/Forms/SellForm.jsx");
import(/* webpackMode: "eager" */ "/app/components/Nav.jsx");
import(/* webpackMode: "eager" */ "/app/components/Pages/LinkTabsBlock.jsx");
import(/* webpackMode: "eager" */ "/app/components/ProjectCardSlider.jsx");
import(/* webpackMode: "eager" */ "/app/components/PropertyCardSlider.jsx");
import(/* webpackMode: "eager" */ "/app/components/ReviewsSlider.jsx");
import(/* webpackMode: "eager" */ "/app/components/SearchFilters/FrontSearchBarStyle2.jsx");
import(/* webpackMode: "eager" */ "/app/components/TestamonialCard.jsx");
import(/* webpackMode: "eager" */ "/app/components/TransportCardSlider.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js")